import React from "react"
import { DndProvider } from "react-dnd"
import { TouchBackend } from "react-dnd-touch-backend"
import { useDispatch, useSelector } from "react-redux"
import { addDepartment, facilityId } from "reduxSlices/adminFacilitySlice"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import CreateDepartmentModal from "shared/modals/CreateDepartmentModal"
import DepartmentList from "./DepartmentList"
import DepartmentMembersDragLayer from "./DepartmentMembersDragLayer"
import DepartmentMembershipInstructions from "./DepartmentMembershipInstructions"
import SearchableMembers from "./SearchableMembers"

const DepartmentsTab = () => {
  const dispatch = useDispatch()

  const { pluralName: departmentsName } = useCustomName(DEPARTMENT_KEY)

  const id = useSelector(facilityId)

  const storeNewDepartment = (department) => dispatch(addDepartment(department))

  return (
    <DndProvider backend={TouchBackend} options={{ enableMouseEvents: true }}>
      <div className="flex justify-between">
        <div className="flex-grow max-w-45">
          <h2 className="tab-title">{departmentsName}</h2>
          <DepartmentList />
          <CreateDepartmentModal
            facilityId={id}
            onDepartmentCreated={storeNewDepartment}
          />
        </div>
        <div className="flex-grow max-w-45 sticky top-20 max-h-max flex flex-col">
          <h2 className="tab-title">Users</h2>
          <SearchableMembers className="mb-4" />
          <DepartmentMembershipInstructions />
        </div>
      </div>
      <DepartmentMembersDragLayer />
    </DndProvider>
  )
}

export default DepartmentsTab
